import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faCalculator, faArrowRight } from '@fortawesome/free-solid-svg-icons';

// Body of the CgPopover triggered from the "Powered by Carbon Glance" badge.
// The popover title ("Key calculation assumptions") is rendered by CgPopover
// itself via the popoverTitle prop, so this content starts straight into the
// substance.
const MethodologyContent = () => (
  <div className="space-y-3 min-w-[320px] max-w-[400px] py-1">
    {/* Data assumptions */}
    <div className="space-y-1">
      <p className="text-xs font-medium text-gray-700 flex items-center gap-1.5">
        <FontAwesomeIcon
          icon={faDatabase}
          className="text-primaryColor text-[10px]"
        />
        Data assumptions
      </p>
      <ul className="bg-gray-50 rounded-lg p-2 space-y-1.5 text-xs text-gray-600 list-disc list-inside">
        <li>
          <span className="font-medium text-gray-800">Emission factors</span> — Country-specific
          default values as published by the European Commission
        </li>
        <li>
          <span className="font-medium text-gray-800">Benchmarks</span> — Column B Benchmarks
          published by the European Commission with the respective product method combined correctly
          with the default values published by the European Commission
        </li>
        <li>
          <span className="font-medium text-gray-800">CBAM Factor</span> — Chargeable share of
          emissions for the year of import
        </li>
        <li>
          <span className="font-medium text-gray-800">Certificate price</span> — Customizable by the
          user, our dropdown features the latest weekly price powered by the European Energy
          Exchange (EEX)
        </li>
      </ul>
    </div>

    {/* Calculation */}
    <div className="space-y-1">
      <p className="text-xs font-medium text-gray-700 flex items-center gap-1.5">
        <FontAwesomeIcon
          icon={faCalculator}
          className="text-primaryColor text-[10px]"
        />
        How it's combined
      </p>
      <div className="bg-purple-50 rounded-lg p-2 space-y-1.5 text-xs text-gray-700">
        <p>
          <span className="bg-purple-200 text-purple-800 px-1.5 py-0.5 rounded text-[10px] font-semibold mr-1">
            1
          </span>
          Specific Embedded Free Allocation = Column B Benchmark × CBAM factor
        </p>
        <p>
          <span className="bg-purple-200 text-purple-800 px-1.5 py-0.5 rounded text-[10px] font-semibold mr-1">
            2
          </span>
          Chargeable emissions = Specific Embedded Emissions (SEE) − Specific Embedded Free
          Allocation (SEFA)
        </p>
        <p>
          <span className="bg-purple-200 text-purple-800 px-1.5 py-0.5 rounded text-[10px] font-semibold mr-1">
            3
          </span>
          CBAM cost / tonne = Chargeable emissions × Certificate price
        </p>
        <p className="text-[10px] text-gray-500 pt-1 border-t border-purple-200">
          Direct-only categories (iron &amp; steel, aluminium) substitute direct embedded emissions
          for total embedded emissions in step 2.
        </p>
      </div>
    </div>

    {/* CTA — leverages the indicative-defaults framing above to pitch the
        natural next step: verified supplier-level data. */}
    <a
      href="https://app.carbonglance.com?utm_source=embed&utm_medium=cost-radar&utm_campaign=actual-supplier-costs"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 w-full bg-primaryColor hover:bg-primaryColor/90 text-white text-xs font-semibold px-3 py-2.5 rounded-lg shadow-sm hover:shadow transition-all duration-200 group"
    >
      <span>See actual supplier costs, not just defaults</span>
      <FontAwesomeIcon
        icon={faArrowRight}
        className="text-[11px] transition-transform duration-200 group-hover:translate-x-0.5"
      />
    </a>
  </div>
);

export default MethodologyContent;
